/* Melti PDP — mockup UI controller.
   Visible controls are the approved mockup's; they write into Horizon's real
   <product-form-component> inputs (name="id", name="quantity"). Submission, cart
   drawer and dynamic checkout stay native (product-form.js / cart-drawer.js). */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var value = Number(cents || 0);
    function withDelims(n, decimals, thousands, decimal) {
      var fixed = (n / 100).toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 && decimals > 0 ? parts[0] + decimal + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      return amount(key);
    }).replace(/([.,])00(?!\d)/, '');
    function amount(key) {
      switch (key) {
        case 'amount': return withDelims(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return withDelims(value, 0, ' ', ',');
        default: return withDelims(value, 2, ',', '.');
      }
    }
  }

  function addBusinessDays(n) {
    var d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6 !== 0) n--; }
    return d;
  }
  var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  function fmtDate(d) { return d.getDate() + ' ' + MONTHS[d.getMonth()]; }

  function initProduct(root) {
    var variants = [];
    try { variants = JSON.parse($('[data-melti-variants]', root).textContent); } catch (e) {}
    var moneyFormat = root.getAttribute('data-money-format');
    var section = root.getAttribute('data-section');
    var form = $('form.tfp-form', root);
    var idInput = form ? $('input[name="id"]', form) : null;
    var qtyInput = form ? $('input[name="quantity"]', form) : null;
    var sticky = $('[data-melti-sticky]');
    var stickyImg = $('[data-melti-sticky-img]');

    /* ---------- Gallery ---------- */
    var slides = $$('[data-melti-slide]', root);
    var thumbs = $$('[data-melti-thumb]', root);
    var current = 0;
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== current; });
      thumbs.forEach(function (t, k) {
        t.setAttribute('aria-current', k === current ? 'true' : 'false');
        if (k === current && t.scrollIntoView) {
          var row = t.parentNode;
          var left = t.offsetLeft - row.offsetLeft - (row.clientWidth - t.clientWidth) / 2;
          row.scrollTo({ left: left, behavior: 'smooth' });
        }
      });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(+t.getAttribute('data-melti-thumb')); }); });
    var prev = $('[data-melti-prev]', root), next = $('[data-melti-next]', root);
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    /* ---------- Variant + quantity state (writes the real form inputs) ---------- */
    var tier = 1;
    function variantById(id) { for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i]; return null; }

    function renderState() {
      var v = variantById(idInput && idInput.value) || variants[0];
      if (!v) return;
      $$('[data-melti-price]', root).forEach(function (el) { el.textContent = formatMoney(v.price, moneyFormat); });
      var cmp = $('[data-melti-compare]', root);
      if (cmp) {
        cmp.hidden = !(v.compare > v.price);
        var cv = $('[data-melti-compare-val]', cmp); if (cv) cv.textContent = formatMoney(v.compare, moneyFormat);
      }
      $$('[data-melti-unit]', root).forEach(function (el) { el.textContent = formatMoney(v.price, moneyFormat); });
      $$('[data-melti-tier-total]', root).forEach(function (el) { el.textContent = formatMoney(v.price * (+el.getAttribute('data-melti-tier-total')), moneyFormat); });
      var sp = $('[data-melti-sticky-price]'); if (sp) sp.textContent = formatMoney(v.price * tier, moneyFormat);
      var sq = $('[data-melti-sticky-qty]'); if (sq) sq.textContent = sq.textContent.replace(/\d+\s*$/, String(tier));

      var checked = $('input[name="melti-color-' + section + '"]:checked', root);
      var label = checked ? checked.getAttribute('data-label') : '';
      $$('[data-melti-color-label]').forEach(function (el) { el.textContent = label; });

      $$('[data-melti-atc]').forEach(function (btn) {
        btn.disabled = !v.available;
        if (btn.closest('[data-melti-sticky]')) return;
        btn.textContent = v.available ? root.getAttribute('data-atc') : root.getAttribute('data-soldout');
      });
      var dyn = $('[ref="acceleratedCheckoutButtonContainer"]', root);
      if (dyn) dyn.hidden = !v.available;

      if (stickyImg && checked) {
        var slide = slides[+checked.getAttribute('data-slide')];
        if (slide) { stickyImg.src = slide.currentSrc || slide.src; stickyImg.hidden = false; }
      }
    }

    $$('input[name="melti-color-' + section + '"]', root).forEach(function (r) {
      r.addEventListener('change', function () {
        if (!idInput) return;
        idInput.value = r.value;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', r.value);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {}
        show(+r.getAttribute('data-slide'));
        renderState();
      });
    });

    $$('input[name="melti-tier-' + section + '"]', root).forEach(function (r) {
      r.addEventListener('change', function () {
        tier = +r.value || 1;
        if (qtyInput) qtyInput.value = String(tier);
        renderState();
      });
    });

    /* Keep the initially selected variant's photo in view */
    var initial = $('input[name="melti-color-' + section + '"]:checked', root);
    if (initial && new URL(window.location.href).searchParams.get('variant')) show(+initial.getAttribute('data-slide'));
    renderState();

    /* ---------- Delivery dates (business days) ---------- */
    var ship = (root.getAttribute('data-ship') || '1,3').split(',').map(Number);
    var deliver = (root.getAttribute('data-deliver') || '7,14').split(',').map(Number);
    var d0 = $('[data-melti-d0]', root), d1 = $('[data-melti-d1]', root), d2 = $('[data-melti-d2]', root);
    if (d0) d0.textContent = fmtDate(new Date());
    if (d1) d1.textContent = fmtDate(addBusinessDays(ship[0])) + ' – ' + fmtDate(addBusinessDays(ship[1]));
    if (d2) d2.textContent = fmtDate(addBusinessDays(deliver[0])) + ' – ' + fmtDate(addBusinessDays(deliver[1]));

    /* ---------- Sticky add-to-cart ---------- */
    var buy = $('[data-buy]', root);
    var footer = $('.tfp-ftr');
    var past = false, atEnd = false;
    function syncSticky() {
      if (!sticky) return;
      var on = past && !atEnd;
      sticky.classList.toggle('is-visible', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      var b = $('button', sticky); if (b) b.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('tfp-has-sticky', on);
    }
    if ('IntersectionObserver' in window && buy) {
      new IntersectionObserver(function (es) { past = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; syncSticky(); }).observe(buy);
      if (footer) new IntersectionObserver(function (es) { atEnd = es[0].isIntersecting; syncSticky(); }).observe(footer);
    }
  }

  function initAccordions() {
    $$('.tfp .tfp-acc__btn').forEach(function (b) {
      if (b.__melti) return; b.__melti = true;
      b.addEventListener('click', function () {
        var open = b.getAttribute('aria-expanded') === 'true';
        b.setAttribute('aria-expanded', open ? 'false' : 'true');
        var p = document.getElementById(b.getAttribute('aria-controls'));
        if (p) p.hidden = open;
      });
    });
  }

  function initReviews(root) {
    var items = $$('.tfp-rv', root), page = 1, mode = 'all', PER = 6;
    var pag = $('[data-rv-pag]', root), count = $('[data-rv-count]', root), sort = $('[data-rv-sort]', root);
    function render() {
      var list = items.filter(function (li) { return mode === 'all' || li.getAttribute('data-photos') === '1'; });
      var pages = Math.max(1, Math.ceil(list.length / PER));
      if (page > pages) page = 1;
      items.forEach(function (li) { li.hidden = true; });
      list.slice((page - 1) * PER, page * PER).forEach(function (li) { li.hidden = false; });
      if (count) count.textContent = 'Mostrando ' + list.length + ' reseñas';
      if (pag) {
        pag.innerHTML = '';
        if (pages > 1) for (var i = 1; i <= pages; i++) {
          var b = document.createElement('button');
          b.type = 'button'; b.textContent = String(i);
          b.setAttribute('aria-current', i === page ? 'page' : 'false');
          b.addEventListener('click', (function (n) { return function () { page = n; render(); root.scrollIntoView({ behavior: 'smooth' }); }; })(i));
          pag.appendChild(b);
        }
      }
    }
    if (sort) sort.addEventListener('change', function () { mode = sort.value; page = 1; render(); });
    render();
  }

  function initCartButton() {
    $$('[data-melti-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else window.location.href = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
      });
    });
  }

  function init() {
    $$('[data-melti-product]').forEach(initProduct);
    $$('[data-melti-reviews]').forEach(initReviews);
    initAccordions();
    initCartButton();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
